import React, { memo } from "react";
import { escapeRegExp } from "../../../utils/escapeReg";
import { Link } from "react-daisyui";

interface HighlightTextProps {
    text: string;
    highlight: string;
    navigateToStudy: () => void;
  }
  
  const HighlightTextStudyTable: React.FC<HighlightTextProps> = memo(({ text, highlight, navigateToStudy }) => {
    const escapedHighlight = escapeRegExp(highlight);
    const parts = text.split(new RegExp(`(${escapedHighlight})`, "gi"));
    return (
      <Link onClick={navigateToStudy}>
        {parts.map((part, i) =>
          part.toLowerCase() === highlight.toLowerCase() ? (
            <span key={i} style={{ backgroundColor: "yellow" }}>
              {part}
            </span>
          ) : (
            <span key={i}>{part}</span>
          )
        )}
      </Link>
    );
  });

  export default HighlightTextStudyTable